import { queryParams } from '@/plugins/axios';

export function all(context, payload) {
  const getUrl = `/quick-move-ins/${queryParams(payload)}`;

  return this._vm.$axios.get(getUrl).then((response) => {
    const { data } = response;
    // console.log('store.quick-move-ins.actions.all() axios then', data, status, statusText);

    return context.dispatch('setQuickMoveIns', { data: data.posts });
  });
}

export function setQuickMoveIns(context, payload) {
  // console.log('store.quick-move-ins.actions.setQuickMoveIns()', payload);
  context.commit('setQuickMoveIns', payload.data);

  return payload.data;
}

export function setQuickMoveInAttribute(context, payload) {
  // console.log('store.quick-move-ins.actions.setQuickMoveInAttribute()', payload);
  context.commit('setQuickMoveInAttribute', payload);
}

export function setFilter(context, payload) {
  console.log('store.quick-move-ins.actions.setFilter()', payload);
  context.commit('setFilter', payload);
}
